import { isRefundBlockedByTag } from "../lib/resolutions.lib";
import { usePublicOrder } from "../queries/use-public-order";
import { useIsMerchant } from "./use-is-merchant";

/**
 * True when the refund is offered only because a merchant is browsing: a shop
 * tag marks the order or the product as not refundable for the customer.
 */
export function useRefundTagOverride(orderId: string, lineItemId: string): boolean {
  const { data: order } = usePublicOrder(orderId);
  const isMerchant = useIsMerchant();
  return isMerchant && isRefundBlockedByTag(order?.opt, lineItemId);
}
